export default {
  title: 'Horaires & Emplacement',
  set_different_opening_hours: "Définir des horaires d'ouverture différents pour la livraison",
  delivery_opening_hours: "Horaires d'ouverture livraison",
  sections: {
    general: "Horaires d'ouverture généraux",
    holidays: 'Suspendre les commandes (jours fériés)',
    create_time: "Ajouter un horaire d'ouverture",
    edit_time: "Modifier l'horaire",
    delivery_schedule: 'Horaires de livraison',
  },
  tabs: {
    open_times: "Horaires d'ouverture",
    location: 'Emplacement',
  },
  form: {
    select_all: {
      label: 'Sélectionner tous les jours',
    },
    holiday_starts_at: {
      label: 'Date de début',
    },
    holiday_ends_at: {
      label: 'Date de fin',
    },
    has_delivery_schedule: {
      label: "Définir des horaires d'ouverture différents pour la livraison",
    },
    has_multiple_locations: {
      label: 'Définir des emplacements différents pour la semaine',
    },
  },
  labels: {
    day_location: '{{day}} emplacement {{index}}',
    selected_days: 'Jours sélectionnés',
    orders_paused: 'Commandes en pause',
    open_time: "Heure d'ouverture",
    close_time: 'Heure de fermeture',
  },
  errors: {
    close_time: "L'heure de fermeture ne peut pas être 00:00. Veuillez saisir 23:59",
  },
  buttons: {
    edit: 'Modifier',
    add_schedule_unit: "Ajouter un horaire d'ouverture",
    add_holiday: 'Ajouter un jour férié',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  toasts: {
    changes_got_saved: 'Informations mises à jour avec succès',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
  },
};
